<template>
	<div class="box" lang="en">
		<h3>Wi6te Privacy Policy</h3>
		<div class="vhtml" v-html="htmlText" ></div>
	</div>
</template>

<script>
	import en from '../assets/js/en.js'
	export default {
		data() {
			return {
				htmlText: en,
			}
		},
	}
</script>

<style lang="less" scoped>
	*{
		margin-bottom: 40px;
	}
	h3 {
		text-align: center;
	}
	.box {
		padding: 0px 20px 30px !important;
		margin-top: 50px;
		background: #FFF;
		color: #000;
		font-size: 16px;
	}
	.vhtml /deep/ p {
		margin-bottom: 20px;
		color: #333;
	}
	.vhtml /deep/ .subTitle {
		
		color: #000;
		font-weight: bold;
	}
	.vhtml /deep/ .sub {
		color: #000;
		font-weight: bold;
		font-size: 15px;
	}
</style>